// DE/EN translations for the whole site

export const translations = {
  de: {
    header: {
      navHero: 'Start',
      navUeber: 'Über uns',
      navAblauf: 'Ablauf',
      navEventHub: 'Event Hub',
      navPartner: 'Partner werden',
      navFloorplan: 'Lageplan',
      navSocialWall: 'Social Wall',
      navTeam: 'Team',
      navKontakt: 'Kontakt',
      meinPortal: 'Mein Portal',
      einstellungen: 'Einstellungen',
      adminPanel: 'Admin Panel',
      abmelden: 'Abmelden',
      anmelden: 'Anmelden',
      registrieren: 'Registrieren',
      menuOpen: 'Menü öffnen',
      menuClose: 'Menü schließen',
      ticketPruefen: 'Ticket prüfen',
    },
    footer: {
      tagline: 'Wo Fußball auf Karriere trifft.',
      quickLinks: 'Quick Links',
      ueberMesse: 'Über die Messe',
      programm: 'Programm',
      aussteller: 'Aussteller',
      fuerAussteller: 'Für Aussteller',
      kontakt: 'Kontakt',
      folgenSie: 'Folgen Sie uns',
      copyright: '© 2026 Next Gen Business Cup. Alle Rechte vorbehalten.',
      impressum: 'Impressum',
      datenschutz: 'Datenschutz',
      agb: 'AGB',
    },
    team: {
      orgTeamTitle: 'Organisations-Team',
      teamAnsehenLink: 'Team ansehen',
      teamZurueck: 'Zurück',
      teamInstruction: 'Klicke auf einen Bereich, um die Teammitglieder mit Namen und Position zu sehen.',
      wirdGeladen: 'Wird geladen...',
    },
    home: {
      mainPartner: 'Champion Partner',
      register: 'Jetzt registrieren',
      partnerWerden: 'Jetzt Partner werden',
      partnerWerdenShort: 'Partner werden',
      ticketKaufen: 'Ticket kaufen',
      ticketsKaufen: 'Tickets kaufen',
      unserePartner: 'Unsere Partner',
      unserePartnerSub: 'Unternehmen, die den Next Gen Business Cup mitgestalten',
      partnerWerdenSectionTitle: 'Partner werden',
      partnerWerdenSectionSub: 'Informationen und Kontaktmöglichkeiten für Partner',
      keyFactsCaps: 'KEY FACTS',
      kontaktformularCaps: 'KONTAKTFORMULAR',
      partnerFact1: '8 teilnehmende Universitäten',
      partnerFact2: '800+ Besucher',
      partnerFact3: 'Zugang zu Kölns nächster Generation an Talenten',
      partnerFact4: 'Hohe Sichtbarkeit für jedes Unternehmen',
      partnerFact5: 'Limitierte Ausstellerplätze',
      partnerFact6: 'Inspirierende Vorträge und Impulse',
      firmaStar: 'Firma*',
      emailStar: 'E-Mail*',
      telefonOptionalField: 'Telefon (optional)',
      socialWallCollageCaption: 'Hier verschiedene Bilder aus Straßenkicker Base (aufgenommen von uns)',
      socialWallPostsPlaceholder: '(Letzte Posts werden angezeigt)',
      socialWallTikTokViewAll: 'Alle Beiträge auf TikTok ansehen',
      interestPiqued: 'Interesse geweckt?',
      teamPillManagement: 'Management',
      teamPillSports: 'Sports',
      teamPillMarketing: 'Marketing',
      teamPillFinance: 'Finance',
      teamPillDigital: 'Digitalisierung & AI CV Matching',
      teamPillSponsoring: 'Sponsoring',
      teamPillUniversity: 'University Contacts',
      aktuellerPreis: 'Aktueller Preis',
      studiPreis: 'Studi-Preis mit Uni-Code',
      ticketsVerfuegbar: 'Noch {n} Tickets verfügbar',
      ausverkauft: 'Ausverkauft',
      preiseLaden: 'Preise werden geladen…',
      wasIst: 'Was ist der Next Gen Business Cup?',
      ueberBeschreibung: 'Der Next Gen Business Cup ist Deutschlands führende Plattform für Innovation, Networking und Geschäftsentwicklung.',
      weiterePartner: 'Weitere Partner',
      championPartner: 'Champion Partner',
      soonAnnounced: 'Soon to be announced',
      championPartner: 'Champion Partner',
      premiumPartner: 'Premium Partner',
      partner: 'Partner',
      performancePartner: 'Performance Partner',
      ablauf: 'Ablauf',
      ablaufSub: 'Programm der Next Gen Stage und digitaler Turnierplan',
      nextGenStage: 'Next Gen Stage Programm',
      programmBekannt: 'Programm wird noch bekannt gegeben',
      turnierplan: 'Digitaler Turnierplan',
      turnierplanBekannt: 'Turnierplan wird noch bekannt gegeben',
      freutEuchProgramm: 'Freut euch auf ein spannendes und inspirierendes Programm!',
      freutEuchSpiele: 'Freut euch auf spannende Spiele!',
      fuerAussteller: 'Für Aussteller',
      fuerAusstellerSub: 'Informationen und Kontaktmöglichkeiten für Aussteller',
      fuerAusstellerTitle: 'Für Aussteller',
      keyFacts: 'Key Facts',
      keyFactsTitle: 'Key Facts',
      keyFact1: '8 teilnehmende Universitäten',
      keyFact2: '800+ Teilnehmende',
      keyFact3: 'Zugang zu Kölns nächster Generation an Talenten',
      keyFact4: 'Hohe Sichtbarkeit für jedes Unternehmen',
      keyFact5: 'Limitierte Ausstellerplätze',
      keyFact6: 'Inspirierende Vorträge & Impulse',
      keyFact7: 'Gezielte Networking-Möglichkeiten',
      vieleFuehrendeUnternehmen: 'Viele führende Unternehmen',
      inspirierendeVoertraege: 'Inspirierende Vorträge',
      networkingOpportunitaeten: 'Networking Opportunitäten',
      floorplan: 'Floorplan',
      floorplanPlaceholder: 'Floorplan wird noch erstellt',
      floorplanEnlarge: 'Klicken zum Vergrößern',
      turnierplanEnlarge: 'Klicken zum Vergrößern',
      kontaktformular: 'Kontaktformular',
      firma: 'Firma *',
      email: 'E-Mail *',
      telefonOptional: 'Telefon (optional)',
      absenden: 'Absenden',
      socialWall: 'Social Wall',
      socialWallSub: 'Folgen Sie uns auf unseren Social Media Kanälen',
      socialWallLinkedInViewAll: 'Alle Beiträge auf LinkedIn ansehen',
      socialWallInstagramViewAll: 'Alle Beiträge auf Instagram ansehen',
      orgTeam: 'Organisations-Team',
      orgTeamSub: 'Das Team hinter dem Next Gen Business Cup',
      teamAnsehen: 'Team ansehen',
      contactTitle: 'Kontakt',
      contactSub: 'Haben Sie Fragen? Kontaktieren Sie uns - wir helfen Ihnen gerne weiter!',
      emailLabel: 'E-Mail',
      telefon: 'Telefon',
      adresse: 'Adresse',
      ticketDialogTitle: 'Ticket kaufen',
      ticketDialogDesc: 'Bitte melden Sie sich an oder registrieren Sie sich, um ein Ticket zu kaufen.',
      login: 'Anmelden',
      loginTitle: 'Anmelden',
      loginDesc: 'Melden Sie sich mit Ihren Zugangsdaten an',
      passwort: 'Passwort',
      noAccount: 'Noch kein Konto?',
      jetztRegistrieren: 'Jetzt registrieren',
      registerTitle: 'Registrieren',
      registerDesc: 'Erstellen Sie ein neues Konto',
      vorname: 'Vorname',
      nachname: 'Nachname',
      agbAkzeptieren: 'Bitte akzeptieren Sie die AGB',
      agbLabel: 'Ich akzeptiere die',
      agb: 'AGB',
      und: 'und die',
      datenschutzerklaerung: 'Datenschutzerklärung',
      bereitsKonto: 'Bereits ein Konto?',
      jetztAnmelden: 'Jetzt anmelden',
      partnerRegisterTitle: 'Als Partner registrieren',
      partnerRegisterDesc: 'Registrieren Sie Ihr Unternehmen als Partner',
      firmenname: 'Firmenname *',
      vornameVertreter: 'Vorname des Vertreters *',
      nachnameVertreter: 'Nachname des Vertreters *',
      telefonOptionalLabel: 'Telefon (optional)',
      passwortLabel: 'Passwort *',
      alsPartnerRegistrieren: 'Als Partner registrieren',
      detailsSoon: 'Details werden bald bekannt gegeben.',
      close: 'Schließen',
      company: 'Firma',
      user: 'User',
      logoAlt: 'Next Gen Business Cup Logo',
      floorplanAlt: 'Floorplan',
      eventLocation: 'Veranstaltungsort',
    },
    portal: {
      welcome: 'Willkommen, {name}!',
      subtitle: 'Ihr persönlicher Bereich für den Next Gen Business Cup',
      karriere: 'Karriere',
      stellenmarkt: 'Stellenmarkt',
      matching: 'Matching',
      karrierePortal: 'Karriere Portal',
      karriereDesc: 'Laden Sie Ihren Lebenslauf hoch für intelligentes AI-Matching',
      ihrLebenslauf: 'Ihr Lebenslauf',
      cvUpload: 'Lebenslauf hochladen',
      cvFormats: 'PDF, DOCX oder TXT (max. 5MB)',
      dateiAuswaehlen: 'Datei auswählen',
      aiMatchingTitle: 'AI-Powered Matching',
      aiMatchingDesc: 'Unsere KI analysiert Ihren Lebenslauf und findet die perfekten Job-Matches für Sie. Ihre Daten werden vertraulich behandelt und nur für das Matching verwendet.',
      ersetzen: 'Ersetzen',
      hochgeladenAm: 'Hochgeladen am',
      aiAnalyseStarten: 'AI-Analyse starten',
      ihrProfil: 'Ihr Profil',
      gewuenschtePosition: 'Gewünschte Position',
      positionPlaceholder: 'z.B. Software Developer, Marketing Manager',
      branche: 'Branche',
      erfahrungslevel: 'Erfahrungslevel',
      profilSpeichern: 'Profil speichern',
      tip: 'Tipp',
      tipText: 'Je vollständiger Ihr Profil, desto besser können wir passende Unternehmen für Sie finden!',
      stellenmarktTitle: 'Stellenmarkt',
      stellenmarktUser: 'Entdecken Sie spannende Karrieremöglichkeiten',
      stellenmarktCompany: 'Veröffentlichen Sie Ihre Stellenausschreibungen',
      neueStelleAusschreiben: 'Neue Stelle ausschreiben',
      neueStelleErstellen: 'Neue Stellenausschreibung erstellen',
      positionsbezeichnung: 'Positionsbezeichnung *',
      standort: 'Standort *',
      beschaeftigungsart: 'Beschäftigungsart *',
      vollzeit: 'Vollzeit',
      teilzeit: 'Teilzeit',
      werkstudent: 'Werkstudent',
      praktikum: 'Praktikum',
      gehaltsspanne: 'Gehaltsspanne',
      skillsPlaceholder: 'z.B. React, Node.js, AWS',
      stellenbeschreibung: 'Stellenbeschreibung *',
      beschreibungPlaceholder: 'Beschreiben Sie die Position...',
      abbrechen: 'Abbrechen',
      stelleVeröffentlichen: 'Stelle veröffentlichen',
      bewerben: 'Bewerben',
      matchingTitle: 'AI-Powered Matching',
      matchingUser: 'Unsere KI hat perfekte Job-Matches für Sie gefunden',
      matchingCompany: 'Unsere KI hat die besten Kandidaten für Ihre Positionen gefunden',
      topMatchesGefunden: '{n} Top Matches gefunden!',
      basierendAufProfil: 'Basierend auf Ihrem Profil und unserer AI-Analyse',
      besterMatch: 'Bester Match',
      terminVereinbaren: 'Termin vereinbaren',
      profilAnsehen: 'Profil ansehen',
      bereitsGebucht: 'Bereits gebucht',
      gebuchteTermine: 'Ihre gebuchten Termine',
      match: 'Match',
      skillsLabel: 'Erforderliche Fähigkeiten (kommagetrennt)',
      // Home section additional
      fuerAusstellerTitle: 'Für Aussteller',
      keyFactsTitle: 'Key Facts',
      vieleFuehrendeUnternehmen: 'Viele führende Unternehmen',
      inspirierendeVoertraege: 'Inspirierende Vorträge',
      networkingOpportunitaeten: 'Networking Opportunitäten',
      floorplanEnlarge: 'Klicken zum Vergrößern',
      turnierplanEnlarge: 'Klicken zum Vergrößern',
      // Kaufen.jsx
      ticketKaufenTitle: 'Ticket kaufen',
      preiseWerdenGeladen: 'Preise werden geladen…',
      aktuellerPreisLabel: 'Aktueller Preis:',
      studiPreisLabel: 'Studi-Preis mit Uni-Code:',
      ticketsVerfuegbarLabel: 'Noch {n} Tickets verfügbar',
      rechnungsadresse: 'Rechnungsadresse',
      rechnungsadresseInfo: 'Für die Rechnung benötigen wir Ihre vollständige Adresse. Die Rechnung und den QR-Code erhalten Sie nach dem Kauf per E-Mail.',
      nameFirma: 'Name *',
      strasseHausnummer: 'Straße und Hausnummer *',
      ort: 'Ort *',
      land: 'Land',
      plz: 'PLZ *',
      hochschulCodeOptional: 'Hochschul-/Uni-Rabattcode (optional)',
      rechtlicheHinweise: 'Rechtliche Hinweise',
      agbAkzeptiert: 'Ich habe die AGB gelesen und akzeptiere diese. *',
      agbLink: 'AGB',
      widerrufsrechtAkzeptiert: 'Ich habe das Widerrufsrecht zur Kenntnis genommen. *',
      widerrufsrecht: 'Widerrufsrecht',
      datenschutzerklaerungLink: 'Datenschutzerklärung',
      datenschutzAkzeptiert: 'Ich habe die Datenschutzerklärung gelesen und akzeptiere die Verarbeitung meiner Daten. *',
      kaufErfolgInfo: 'Nach dem Kauf erhältst du eine E-Mail mit Rechnung und deinem persönlichen QR-Code. Den QR-Code findest du auch im Dashboard.',
      weiterleitungZahlung: 'Weiterleitung zur Zahlung…',
      jetztKaufen: 'Jetzt kaufen – zur Zahlung',
      ausverkauftLabel: 'Ausverkauft',
    },
    dashboard: {
      willkommenZurueck: 'Willkommen zurück!',
      vertretenDurch: 'Vertreten durch:',
      vertreter: 'Vertreter',
      ticketPruefen: 'Ticket prüfen',
      abmelden: 'Abmelden',
      zahlungErfolgreich: 'Zahlung erfolgreich!',
      zahlungErfolgreichDesc: 'Dein Ticket ist bestätigt. Du erhältst in Kürze eine E-Mail mit der Rechnung. Das Ticket erscheint unten sobald es freigeschaltet ist.',
      zahlungAbgebrochen: 'Zahlung abgebrochen',
      zahlungAbgebrochenDesc: 'Du kannst jederzeit erneut ein Ticket kaufen.',
      einstellungen: 'Einstellungen',
      einstellungenDesc: 'Verwalten Sie Ihre persönlichen Daten und Präferenzen',
      einstellungenCompanyDesc: 'Verwalten Sie Ihre Firmendaten und Präferenzen',
      oeffnen: 'Öffnen',
      eintrittsticketQr: 'Eintrittsticket & QR-Code',
      ticketsLaden: 'Tickets werden geladen...',
      gueltigesTicket: 'Du hast ein gültiges Ticket für den Next Gen Business Cup.',
      qrWirdGeladen: 'QR wird geladen…',
      qrFehler: 'QR konnte nicht geladen werden.',
      erneutVersuchen: 'Erneut versuchen',
      eintrittsticket: 'Eintrittsticket',
      kategorie: 'Kategorie',
      preis: 'Preis',
      qrAmEinlass: 'Zeigen Sie diesen QR-Code am Einlass vor.',
      einTicketZugang: 'Ein Ticket – Zugang zum gesamten Event. Karrieremesse + Fußballturnier.',
      studiRabatt: 'Studierendenrabatt über deine Uni: Mit Code nur 3 €.',
      aktuellerPreis: 'Aktueller Preis',
      studiPreisCode: 'Studi-Preis mit Uni-Code',
      hochschulCode: 'Hochschul-/Uni-Rabattcode',
      codePlaceholder: 'z.B. HS-MUENCHEN-2026',
      weiterleitungZahlung: 'Weiterleitung zur Zahlung...',
      ticketJetztKaufen: 'Ticket jetzt kaufen',
      ausverkauft: 'Ausverkauft',
      fehlerTickets: 'Fehler beim Laden deiner Tickets',
      fehlerCheckout: 'Konnte keine Zahlungs-Session erstellen',
      fehlerZahlung: 'Fehler beim Starten des Zahlungsprozesses',
      meinZeitplan: 'Mein Zeitplan',
      zeitplanDesc: 'Verwalten Sie Ihre geplanten Veranstaltungen',
      zeitplanAnzeigen: 'Zeitplan anzeigen',
      firmenZeitplan: 'Firmen-Zeitplan',
      firmenZeitplanDesc: 'Verwalten Sie die geplanten Veranstaltungen für Ihr Unternehmen',
      platzhalter: 'Platzhalter',
      weitereFunktionen: 'Weitere Funktionen folgen',
      qrCode: 'QR-Code',
      qrCodeDesc: 'Zeigen Sie Ihren QR-Code für den Einlass vor',
      qrCodeAnzeigen: 'QR-Code anzeigen',
    },
    admin: {
      zurueckDashboard: 'Zurück zum Dashboard',
      userVerwaltung: 'User-Verwaltung & Rollen',
      ticketKontrolle: 'Ticket-Kontrolle',
      ticketRabatt: 'Ticket prüfen & Rabattcodes',
      userVerwaltungTab: 'User-Verwaltung',
      rabattcodes: 'Rabattcodes',
      ticketPruefen: 'Ticket prüfen',
      ticketPruefenDesc: 'QR-Code scannen oder Token einfügen. Nach dem Scannen bleibt die Kamera an.',
      tickets: 'Tickets',
      gesamt: 'Gesamt',
      admins: 'Admins',
      manager: 'Manager',
      ticketController: 'Ticket-Controller',
      user: 'User',
      suchePlaceholder: 'Suche nach Name oder E-Mail...',
      alle: 'Alle',
      name: 'Name',
      email: 'E-Mail',
      typ: 'Typ',
      registriert: 'Registriert',
      rollen: 'Rollen',
      aktionen: 'Aktionen',
      admin: 'Admin',
      adminEntfernen: 'Admin entfernen',
      managerEntfernen: 'Manager entfernen',
      ticketControllerEntfernen: 'Ticket-Controller entfernen',
      loeschen: 'Löschen',
      keineUser: 'Keine User gefunden',
      ladeUser: 'Lade User-Liste...',
      erneutVersuchen: 'Erneut versuchen',
      firma: 'Firma',
      userType: 'User',
      neuAnlegen: 'Neu anlegen',
      hochschule: 'Hochschule',
      code: 'Code',
      aktiv: 'Aktiv',
      nutzungen: 'Nutzungen',
      qrScannen: 'QR-Code scannen',
      kameraStarten: 'Kamera starten',
      kameraBeenden: 'Kamera beenden',
      oderEinfuegen: 'Oder Token einfügen',
      pruefen: 'Prüfen',
      gueltig: 'Gültig',
      ungueltig: 'Ungültig',
      nochmalPruefen: 'Nochmal prüfen',
      ticketGeprueft: 'Ticket geprüft.',
      fehlerPruefen: 'Fehler beim Prüfen des Tickets.',
      fehlerLadenUser: 'Fehler beim Laden der User-Liste',
      fehlerRolle: 'Fehler beim Aktualisieren der Rolle',
      fehlerLoeschen: 'Fehler beim Löschen des Users',
      fehlerRabatt: 'Fehler beim Anlegen des Rabattcodes',
      fehlerRabattUpdate: 'Fehler beim Aktualisieren des Rabattcodes',
      confirmDelete: 'Möchten Sie den User "{name}" wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden!',
      userGeloescht: 'User erfolgreich gelöscht',
      revokeConfirmTitle: 'Ticket entziehen?',
      revokeConfirmText: 'Ticket wirklich entziehen? Die Person kann danach ein neues kaufen.',
      abbrechen: 'Abbrechen',
      ok: 'OK',
      bitteWarten: 'Bitte warten…',
      // AdminPanel-specific
      rabattcodesTitle: 'Hochschul-/Uni-Rabatte',
      rabattcodesDesc: 'Verwalten Sie Rabattcodes für Hochschulen und Universitäten. Tickets mit diesen Codes kosten 3,00 €.',
      neuenRabattcodeAnlegen: 'Neuen Rabattcode anlegen',
      bestehendeRabattcodes: 'Bestehende Rabattcodes',
      hochschuleLabel: 'Hochschule / Universität *',
      hochschulePlaceholder: 'z.B. Hochschule München',
      qrInhaltEinfuegen: 'QR-Inhalt einfügen',
      qrInhaltPlaceholder: 'Inhalt aus QR-Scanner einfügen...',
      scanErgebnis: 'Scan- oder Prüfergebnis erscheint hier.',
      bitteWaehlen: '– Bitte wählen –',
      ticketsEingeloest: 'Tickets wurden am Scanner eingelöst',
      // Error messages
      fehlerTicketEntziehen: 'Fehler beim Entziehen des Tickets.',
      fehlerTicketVergeben: 'Fehler beim Vergeben des Tickets',
      bitteUserAuswaehlen: 'Bitte User auswählen.',
      ticketGeprueftMsg: 'Ticket geprüft.',
      ticketsTitle: 'Tickets',
      ticketsDesc: 'Wer hat ein Ticket, was wurde bezahlt, Tickets entziehen oder Gratis-Ticket vergeben.',
      keineRechnung: 'Keine E-Mail/Rechnung. Kategorie erscheint auf dem Ticket (z. B. am QR-Check).',
      userAuswaehlen: 'User auswählen (Name oder E-Mail)',
      kategorie: 'Kategorie',
      ticketErstellen: 'Ticket erstellen',
      alleVergebenenTickets: 'Alle vergebenen Tickets',
      nochKeineTickets: 'Noch keine Tickets vergeben oder Liste wird geladen.',
      eingeloest: 'Eingelöst',
      betrag: 'Betrag',
      status: 'Status',
      aktion: 'Aktion',
      ticketEntziehen: 'Ticket entziehen',
      // Ticket types
      sportler: 'Sportler',
      orgaTeam: 'Orga-Team',
      aussteller: 'Aussteller',
      ticketEntzogen: 'Ticket entzogen',
    },
    legal: {
      impressum: {
        title: 'Impressum',
        section1: 'Angaben gemäß § 5 TMG',
        section2: 'Vertreten durch',
        section3: 'Kontakt',
        section4: 'Registereintrag',
        section5: 'Umsatzsteuer-ID',
        section6: 'Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV',
        section7: 'EU-Streitschlichtung',
        section8: 'Verbraucherstreitbeilegung / Universalschlichtungsstelle',
        section9: 'Haftung für Inhalte',
        section10: 'Haftung für Links',
        section11: 'Urheberrecht',
        placeholderCompany: '[Firmenname / Name des Unternehmens]',
        placeholderStreet: '[Straße und Hausnummer]',
        placeholderPlace: '[PLZ und Ort]',
        placeholderRepresentative: '[Name des Geschäftsführers / Vertretungsberechtigten]',
        placeholderPhone: '[Telefonnummer]',
        placeholderEmail: '[E-Mail-Adresse]',
        placeholderCourt: '[Amtsgericht]',
        placeholderRegNo: '[HRB-Nummer]',
        placeholderUst: '[USt-IdNr.]',
        placeholderResponsible: '[Name]',
        euPlatform: 'Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:',
        euEmailNote: 'Unsere E-Mail-Adresse finden Sie oben im Impressum.',
        noOdr: 'Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.',
        haftungInhalte: 'Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.',
        haftungInhalte2: 'Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.',
        haftungLinks: 'Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.',
        haftungLinks2: 'Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.',
        urheber: 'Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.',
        urheber2: 'Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.',
      },
      agb: {
        title: 'Allgemeine Geschäftsbedingungen (AGB)',
        s1Title: '§ 1 Geltungsbereich',
        s1P1: 'Diese Allgemeinen Geschäftsbedingungen (nachfolgend "AGB") gelten für alle Verträge über die Teilnahme am Next Gen Business Cup sowie für die Nutzung der damit verbundenen Dienstleistungen zwischen dem Veranstalter und den Teilnehmern bzw. Ausstellern.',
        s1P2: 'Abweichende, entgegenstehende oder ergänzende Allgemeine Geschäftsbedingungen des Vertragspartners werden nur dann und insoweit Vertragsbestandteil, als ihrer Geltung ausdrücklich zugestimmt wurde.',
        s2Title: '§ 2 Vertragsschluss',
        s2P1: 'Der Vertrag kommt durch die Anmeldung des Teilnehmers/Ausstellers und die Bestätigung durch den Veranstalter zustande. Die Anmeldung kann online über die Website oder in Textform erfolgen.',
        s2P2: 'Der Veranstalter behält sich vor, Anmeldungen ohne Angabe von Gründen abzulehnen. Ein Anspruch auf Teilnahme besteht nicht.',
        stand: 'Stand: Januar 2026',
      },
      datenschutz: {
        title: 'Datenschutzerklärung',
        s1Title: '1. Datenschutz auf einen Blick',
        s1Sub: 'Allgemeine Hinweise',
        s1P1: 'Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.',
        s2Title: '2. Datenerfassung auf dieser Website',
        s2Who: 'Wer ist verantwortlich für die Datenerfassung auf dieser Website?',
        s2WhoP: 'Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.',
        stand: 'Stand: Januar 2026',
      },
    },
  },
  en: {
    header: {
      navHero: 'Home',
      navUeber: 'About',
      navAblauf: 'Schedule',
      navEventHub: 'Event Hub',
      navPartner: 'Become a partner',
      navFloorplan: 'Floorplan',
      navSocialWall: 'Social Wall',
      navTeam: 'Team',
      navKontakt: 'Contact',
      meinPortal: 'My Portal',
      einstellungen: 'Settings',
      adminPanel: 'Admin Panel',
      abmelden: 'Log out',
      anmelden: 'Log in',
      registrieren: 'Register',
      menuOpen: 'Open menu',
      menuClose: 'Close menu',
      ticketPruefen: 'Check ticket',
    },
    footer: {
      tagline: 'Sport • Karriere • Networking',
      quickLinks: 'Quick Links',
      ueberMesse: 'About the event',
      programm: 'Programme',
      aussteller: 'Exhibitors',
      fuerAussteller: 'For exhibitors',
      kontakt: 'Contact',
      folgenSie: 'Follow us',
      copyright: '© 2026 Next Gen Business Cup. All rights reserved.',
      impressum: 'Imprint',
      datenschutz: 'Privacy',
      agb: 'Terms',
    },
    team: {
      orgTeamTitle: 'Organising team',
      teamAnsehenLink: 'View team',
      teamZurueck: 'Back',
      teamInstruction: 'Click on a category to see team members with name and position.',
      wirdGeladen: 'Loading...',
    },
    home: {
      mainPartner: 'Champion partners',
      register: 'Register now',
      partnerWerden: 'Become a partner',
      partnerWerdenShort: 'Become a partner',
      ticketKaufen: 'Buy ticket',
      ticketsKaufen: 'Buy tickets',
      unserePartner: 'Our partners',
      unserePartnerSub: 'Companies shaping the Next Gen Business Cup with us',
      partnerWerdenSectionTitle: 'Become a partner',
      partnerWerdenSectionSub: 'Information and contact options for partners',
      keyFactsCaps: 'KEY FACTS',
      kontaktformularCaps: 'CONTACT FORM',
      partnerFact1: '8 participating universities',
      partnerFact2: '800+ visitors',
      partnerFact3: "Access to Cologne's next generation of talent",
      partnerFact4: 'High visibility for every company',
      partnerFact5: 'Limited exhibitor spaces',
      partnerFact6: 'Inspiring talks and impulses',
      firmaStar: 'Company*',
      emailStar: 'Email*',
      telefonOptionalField: 'Phone (optional)',
      socialWallCollageCaption: 'Various photos from Straßenkicker Base (taken by us)',
      socialWallPostsPlaceholder: '(Latest posts are shown)',
      socialWallTikTokViewAll: 'View all posts on TikTok',
      interestPiqued: 'Interested?',
      teamPillManagement: 'Management',
      teamPillSports: 'Sports',
      teamPillMarketing: 'Marketing',
      teamPillFinance: 'Finance',
      teamPillDigital: 'Digitalisation & AI CV matching',
      teamPillSponsoring: 'Sponsoring',
      teamPillUniversity: 'University contacts',
      aktuellerPreis: 'Current price',
      studiPreis: 'Student price with university code',
      ticketsVerfuegbar: '{n} tickets still available',
      ausverkauft: 'Sold out',
      preiseLaden: 'Loading prices…',
      wasIst: 'What is the Next Gen <span class="italic font-normal">Business</span> Cup?',
      ueberBeschreibung: 'The Next Gen Business Cup is Germany\'s leading platform for innovation, networking and business development.',
      weiterePartner: 'More partners',
      championPartner: 'Champion Partners',
      premiumPartner: 'Premium Partners',
      soonAnnounced: 'Soon to be announced',
      partner: 'Partners',
      performancePartner: 'Performance partners',
      ablauf: 'Schedule',
      ablaufSub: 'Next Gen Stage programme and digital tournament schedule',
      nextGenStage: 'Next Gen Stage programme',
      programmBekannt: 'Programme to be announced',
      turnierplan: 'Digital tournament schedule',
      turnierplanBekannt: 'Tournament schedule to be announced',
      freutEuchProgramm: 'Get ready for an exciting and inspiring programme!',
      freutEuchSpiele: 'Get ready for exciting games!',
      fuerAussteller: 'For exhibitors',
      fuerAusstellerSub: 'Information and contact options for exhibitors',
      fuerAusstellerTitle: 'For exhibitors',
      keyFacts: 'Key facts',
      keyFactsTitle: 'Key facts',
      keyFact1: '8 participating universities',
      keyFact2: '800+ participants',
      keyFact3: 'Access to Cologne\'s next generation of talent',
      keyFact4: 'High visibility for every company',
      keyFact5: 'Limited exhibitor spaces',
      keyFact6: 'Inspiring talks & impulses',
      keyFact7: 'Targeted networking opportunities',
      vieleFuehrendeUnternehmen: 'Many leading companies',
      inspirierendeVoertraege: 'Inspiring talks',
      networkingOpportunitaeten: 'Networking opportunities',
      floorplan: 'Floor plan',
      floorplanPlaceholder: 'Floor plan to be created',
      floorplanEnlarge: 'Click to enlarge',
      turnierplanEnlarge: 'Click to enlarge',
      kontaktformular: 'Contact form',
      firma: 'Company *',
      email: 'Email *',
      telefonOptional: 'Phone (optional)',
      absenden: 'Submit',
      socialWall: 'Social Wall',
      socialWallSub: 'Follow us on our social media channels',
      socialWallLinkedInViewAll: 'View all posts on LinkedIn',
      socialWallInstagramViewAll: 'View all posts on Instagram',
      orgTeam: 'Organising team',
      orgTeamSub: 'The team behind the Next Gen Business Cup',
      teamAnsehen: 'View team',
      contactTitle: 'Contact',
      contactSub: 'Got questions? Get in touch - we\'re happy to help!',
      emailLabel: 'Email',
      telefon: 'Phone',
      adresse: 'Address',
      ticketDialogTitle: 'Buy ticket',
      ticketDialogDesc: 'Please log in or register to purchase a ticket.',
      login: 'Log in',
      loginTitle: 'Log in',
      loginDesc: 'Sign in with your credentials',
      passwort: 'Password',
      noAccount: 'Don\'t have an account?',
      jetztRegistrieren: 'Register now',
      registerTitle: 'Register',
      registerDesc: 'Create a new account',
      vorname: 'First name',
      nachname: 'Last name',
      agbAkzeptieren: 'Please accept the terms and conditions',
      agbLabel: 'I accept the',
      agb: 'Terms',
      und: 'and the',
      datenschutzerklaerung: 'Privacy Policy',
      bereitsKonto: 'Already have an account?',
      jetztAnmelden: 'Log in',
      partnerRegisterTitle: 'Register as partner',
      partnerRegisterDesc: 'Register your company as a partner',
      firmenname: 'Company name *',
      vornameVertreter: 'Representative first name *',
      nachnameVertreter: 'Representative last name *',
      telefonOptionalLabel: 'Phone (optional)',
      passwortLabel: 'Password *',
      alsPartnerRegistrieren: 'Register as partner',
      detailsSoon: 'Details will be revealed soon.',
      close: 'Close',
      company: 'Company',
      user: 'User',
      logoAlt: 'Next Gen Business Cup Logo',
      floorplanAlt: 'Floorplan',
      eventLocation: 'Event Location',
    },
    portal: {
      welcome: 'Welcome, {name}!',
      subtitle: 'Your personal area for the Next Gen Business Cup',
      karriere: 'Career',
      stellenmarkt: 'Job market',
      matching: 'Matching',
      karrierePortal: 'Career portal',
      karriereDesc: 'Upload your CV for smart AI matching',
      ihrLebenslauf: 'Your CV',
      cvUpload: 'Upload CV',
      cvFormats: 'PDF, DOCX or TXT (max. 5MB)',
      dateiAuswaehlen: 'Select file',
      aiMatchingTitle: 'AI-Powered Matching',
      aiMatchingDesc: 'Our AI analyses your CV and finds the best job matches for you. Your data is treated confidentially and used only for matching.',
      ersetzen: 'Replace',
      hochgeladenAm: 'Uploaded on',
      aiAnalyseStarten: 'Start AI analysis',
      ihrProfil: 'Your profile',
      gewuenschtePosition: 'Desired position',
      positionPlaceholder: 'e.g. Software Developer, Marketing Manager',
      branche: 'Industry',
      erfahrungslevel: 'Experience level',
      profilSpeichern: 'Save profile',
      tip: 'Tip',
      tipText: 'The more complete your profile, the better we can find matching companies for you!',
      stellenmarktTitle: 'Job market',
      stellenmarktUser: 'Discover exciting career opportunities',
      stellenmarktCompany: 'Publish your job listings',
      neueStelleAusschreiben: 'Post new job',
      neueStelleErstellen: 'Create new job listing',
      positionsbezeichnung: 'Job title *',
      standort: 'Location *',
      beschaeftigungsart: 'Employment type *',
      vollzeit: 'Full-time',
      teilzeit: 'Part-time',
      werkstudent: 'Working student',
      praktikum: 'Internship',
      gehaltsspanne: 'Salary range',
      skillsPlaceholder: 'e.g. React, Node.js, AWS',
      skillsLabel: 'Required skills (comma-separated)',
      stellenbeschreibung: 'Job description *',
      beschreibungPlaceholder: 'Describe the position...',
      abbrechen: 'Cancel',
      stelleVeröffentlichen: 'Publish job',
      bewerben: 'Apply',
      matchingTitle: 'AI-Powered Matching',
      matchingUser: 'Our AI has found perfect job matches for you',
      matchingCompany: 'Our AI has found the best candidates for your positions',
      topMatchesGefunden: '{n} top matches found!',
      basierendAufProfil: 'Based on your profile and our AI analysis',
      besterMatch: 'Best match',
      terminVereinbaren: 'Book appointment',
      profilAnsehen: 'View profile',
      bereitsGebucht: 'Already booked',
      gebuchteTermine: 'Your booked appointments',
      match: 'Match',
      skillsLabel: 'Required skills (comma-separated)',
      // Home section additional
      fuerAusstellerTitle: 'For exhibitors',
      keyFactsTitle: 'Key facts',
      vieleFuehrendeUnternehmen: 'Many leading companies',
      inspirierendeVoertraege: 'Inspiring talks',
      networkingOpportunitaeten: 'Networking opportunities',
      floorplanEnlarge: 'Click to enlarge',
      turnierplanEnlarge: 'Click to enlarge',
      // Kaufen.jsx
      ticketKaufenTitle: 'Buy ticket',
      preiseWerdenGeladen: 'Loading prices…',
      aktuellerPreisLabel: 'Current price:',
      studiPreisLabel: 'Student price with uni code:',
      ticketsVerfuegbarLabel: '{n} tickets still available',
      rechnungsadresse: 'Billing address',
      rechnungsadresseInfo: 'We need your full address for the invoice. You will receive the invoice and QR code by email after purchase.',
      nameFirma: 'Name *',
      strasseHausnummer: 'Street and number *',
      ort: 'City *',
      land: 'Country',
      plz: 'Postcode *',
      hochschulCodeOptional: 'University discount code (optional)',
      rechtlicheHinweise: 'Legal information',
      agbAkzeptiert: 'I have read and accept the Terms and Conditions. *',
      agbLink: 'Terms',
      widerrufsrechtAkzeptiert: 'I have noted the right of withdrawal. *',
      widerrufsrecht: 'Right of withdrawal',
      datenschutzerklaerungLink: 'Privacy Policy',
      datenschutzAkzeptiert: 'I have read and accept the privacy policy for the processing of my data. *',
      kaufErfolgInfo: 'After purchase you will receive an email with the invoice and your personal QR code. You can also find the QR code in the dashboard.',
      weiterleitungZahlung: 'Redirecting to payment…',
      jetztKaufen: 'Buy now – proceed to payment',
      ausverkauftLabel: 'Sold out',
    },
    dashboard: {
      willkommenZurueck: 'Welcome back!',
      vertretenDurch: 'Represented by:',
      vertreter: 'Representative',
      ticketPruefen: 'Check ticket',
      abmelden: 'Log out',
      zahlungErfolgreich: 'Payment successful!',
      zahlungErfolgreichDesc: 'Your ticket is confirmed. You will receive an email with the invoice shortly. The ticket will appear below once activated.',
      zahlungAbgebrochen: 'Payment cancelled',
      zahlungAbgebrochenDesc: 'You can purchase a ticket again at any time.',
      einstellungen: 'Settings',
      einstellungenDesc: 'Manage your personal data and preferences',
      einstellungenCompanyDesc: 'Manage your company data and preferences',
      oeffnen: 'Open',
      eintrittsticketQr: 'Admission ticket & QR code',
      ticketsLaden: 'Loading tickets...',
      gueltigesTicket: 'You have a valid ticket for the Next Gen Business Cup.',
      qrWirdGeladen: 'Loading QR code…',
      qrFehler: 'Could not load QR code.',
      erneutVersuchen: 'Try again',
      eintrittsticket: 'Admission ticket',
      kategorie: 'Category',
      preis: 'Price',
      qrAmEinlass: 'Show this QR code at the entrance.',
      einTicketZugang: 'One ticket – access to the entire event. Career fair + football tournament.',
      studiRabatt: 'Student discount via your university: With code only 3 €.',
      aktuellerPreis: 'Current price',
      studiPreisCode: 'Student price with university code',
      hochschulCode: 'University discount code',
      codePlaceholder: 'e.g. HS-MUENCHEN-2026',
      weiterleitungZahlung: 'Redirecting to payment...',
      ticketJetztKaufen: 'Buy ticket now',
      ausverkauft: 'Sold out',
      fehlerTickets: 'Error loading your tickets',
      fehlerCheckout: 'Could not create payment session',
      fehlerZahlung: 'Error starting payment process',
      meinZeitplan: 'My schedule',
      zeitplanDesc: 'Manage your planned events',
      zeitplanAnzeigen: 'View schedule',
      firmenZeitplan: 'Company schedule',
      firmenZeitplanDesc: 'Manage planned events for your company',
      platzhalter: 'Placeholder',
      weitereFunktionen: 'More features coming soon',
      qrCode: 'QR code',
      qrCodeDesc: 'Show your QR code at the entrance',
      qrCodeAnzeigen: 'Show QR code',
    },
    admin: {
      zurueckDashboard: 'Back to dashboard',
      userVerwaltung: 'User management & roles',
      ticketKontrolle: 'Ticket control',
      ticketRabatt: 'Check tickets & discount codes',
      userVerwaltungTab: 'User management',
      rabattcodes: 'Discount codes',
      ticketPruefen: 'Check ticket',
      ticketPruefenDesc: 'Scan QR code or paste token. After scanning, the camera stays on.',
      tickets: 'Tickets',
      gesamt: 'Total',
      admins: 'Admins',
      manager: 'Managers',
      ticketController: 'Ticket controllers',
      user: 'Users',
      suchePlaceholder: 'Search by name or email...',
      alle: 'All',
      name: 'Name',
      email: 'Email',
      typ: 'Type',
      registriert: 'Registered',
      rollen: 'Roles',
      aktionen: 'Actions',
      admin: 'Admin',
      adminEntfernen: 'Remove admin',
      managerEntfernen: 'Remove manager',
      ticketControllerEntfernen: 'Remove ticket controller',
      loeschen: 'Delete',
      keineUser: 'No users found',
      ladeUser: 'Loading user list...',
      erneutVersuchen: 'Try again',
      firma: 'Company',
      userType: 'User',
      neuAnlegen: 'Create new',
      hochschule: 'University',
      code: 'Code',
      aktiv: 'Active',
      nutzungen: 'Uses',
      qrScannen: 'Scan QR code',
      kameraStarten: 'Start camera',
      kameraBeenden: 'End camera',
      oderEinfuegen: 'Or paste token',
      pruefen: 'Verify',
      gueltig: 'Valid',
      ungueltig: 'Invalid',
      nochmalPruefen: 'Verify again',
      ticketGeprueft: 'Ticket verified.',
      fehlerPruefen: 'Error verifying ticket.',
      fehlerLadenUser: 'Error loading user list',
      fehlerRolle: 'Error updating role',
      fehlerLoeschen: 'Error deleting user',
      fehlerRabatt: 'Error creating discount code',
      fehlerRabattUpdate: 'Error updating discount code',
      confirmDelete: 'Do you really want to delete user "{name}"? This action cannot be undone!',
      userGeloescht: 'User deleted successfully',
      revokeConfirmTitle: 'Revoke ticket?',
      revokeConfirmText: 'Really revoke this ticket? The person can buy a new one afterwards.',
      abbrechen: 'Cancel',
      ok: 'OK',
      bitteWarten: 'Please wait…',
      // AdminPanel-specific
      rabattcodesTitle: 'University discounts',
      rabattcodesDesc: 'Manage discount codes for universities and schools. Tickets with these codes cost €3.00.',
      neuenRabattcodeAnlegen: 'Create new discount code',
      bestehendeRabattcodes: 'Existing discount codes',
      hochschuleLabel: 'University / School *',
      hochschulePlaceholder: 'e.g. University of Munich',
      qrInhaltEinfuegen: 'Paste QR content',
      qrInhaltPlaceholder: 'Paste content from QR scanner...',
      scanErgebnis: 'Scan or verification result will appear here.',
      bitteWaehlen: '– Please select –',
      ticketsEingeloest: 'tickets have been redeemed at the scanner',
      // Error messages
      fehlerTicketEntziehen: 'Error revoking ticket.',
      fehlerTicketVergeben: 'Error assigning ticket',
      bitteUserAuswaehlen: 'Please select a user.',
      ticketGeprueftMsg: 'Ticket verified.',
      ticketsTitle: 'Tickets',
      ticketsDesc: 'Who has a ticket, what was paid, revoke tickets or assign free tickets.',
      keineRechnung: 'No email/invoice. Category appears on the ticket (e.g. at QR check).',
      userAuswaehlen: 'Select user (name or email)',
      kategorie: 'Category',
      ticketErstellen: 'Create ticket',
      alleVergebenenTickets: 'All assigned tickets',
      nochKeineTickets: 'No tickets assigned yet or list is loading.',
      eingeloest: 'Redeemed',
      betrag: 'Amount',
      status: 'Status',
      aktion: 'Action',
      ticketEntziehen: 'Revoke ticket',
      // Ticket types
      sportler: 'Athlete',
      orgaTeam: 'Organizer team',
      aussteller: 'Exhibitor',
      ticketEntzogen: 'Ticket revoked',
    },
    legal: {
      impressum: {
        title: 'Imprint',
        section1: 'Information pursuant to § 5 TMG',
        section2: 'Represented by',
        section3: 'Contact',
        section4: 'Register entry',
        section5: 'VAT ID',
        section6: 'Responsible for content pursuant to § 55(2) RStV',
        section7: 'EU dispute resolution',
        section8: 'Consumer dispute resolution / Universal arbitration board',
        section9: 'Liability for content',
        section10: 'Liability for links',
        section11: 'Copyright',
        placeholderCompany: '[Company name]',
        placeholderStreet: '[Street and number]',
        placeholderPlace: '[Postcode and city]',
        placeholderRepresentative: '[Name of managing director / authorised representative]',
        placeholderPhone: '[Phone number]',
        placeholderEmail: '[Email address]',
        placeholderCourt: '[Local court]',
        placeholderRegNo: '[Registration number]',
        placeholderUst: '[VAT ID no.]',
        placeholderResponsible: '[Name]',
        euPlatform: 'The European Commission provides a platform for online dispute resolution (OS):',
        euEmailNote: 'You can find our email address in the imprint above.',
        noOdr: 'We are not willing or obliged to participate in dispute resolution proceedings before a consumer arbitration board.',
        haftungInhalte: 'As a service provider we are responsible for our own content on these pages in accordance with general law pursuant to § 7(1) TMG. According to §§ 8 to 10 TMG we are not obliged to monitor transmitted or stored third-party information or to investigate circumstances indicating illegal activity.',
        haftungInhalte2: 'Obligations to remove or block the use of information under general law remain unaffected. However, liability in this regard is only possible from the time of knowledge of a specific legal violation. Upon becoming aware of corresponding legal violations we will remove such content immediately.',
        haftungLinks: 'Our site contains links to external third-party websites over whose content we have no influence. We therefore cannot assume any liability for this third-party content. The respective provider or operator of the linked pages is always responsible for the content of the linked pages. The linked pages were checked for possible legal violations at the time of linking. Illegal content was not recognisable at the time of linking.',
        haftungLinks2: 'Permanent monitoring of the content of the linked pages is not reasonable without concrete evidence of a legal violation. Upon becoming aware of legal violations we will remove such links immediately.',
        urheber: 'The content and works created by the site operators on these pages are subject to German copyright law. Duplication, processing, distribution and any kind of exploitation outside the limits of copyright law require the written consent of the respective author or creator. Downloads and copies of this site are only permitted for private, non-commercial use.',
        urheber2: 'In so far as the content on this site was not created by the operator, third-party copyrights are respected. In particular, third-party content is marked as such. Should you become aware of a copyright infringement we ask that you notify us accordingly. Upon becoming aware of legal violations we will remove such content immediately.',
      },
      agb: {
        title: 'Terms and Conditions',
        s1Title: '§ 1 Scope',
        s1P1: 'These General Terms and Conditions ("GTC") apply to all contracts for participation in the Next Gen Business Cup and for the use of associated services between the organiser and participants or exhibitors.',
        s1P2: 'Deviating, conflicting or supplementary terms and conditions of the contracting party shall only become part of the contract if and to the extent that their applicability has been expressly agreed.',
        s2Title: '§ 2 Conclusion of contract',
        s2P1: 'The contract is formed by the participant\'s/exhibitor\'s registration and confirmation by the organiser. Registration may be made online via the website or in text form.',
        s2P2: 'The organiser reserves the right to reject registrations without giving reasons. There is no entitlement to participate.',
        stand: 'As of January 2026',
      },
      datenschutz: {
        title: 'Privacy Policy',
        s1Title: '1. Data protection at a glance',
        s1Sub: 'General information',
        s1P1: 'The following notes provide a simple overview of what happens to your personal data when you visit this website. Personal data is any data with which you can be personally identified. You can find detailed information on the subject of data protection in our privacy policy below this text.',
        s2Title: '2. Data collection on this website',
        s2Who: 'Who is responsible for data collection on this website?',
        s2WhoP: 'Data processing on this website is carried out by the website operator. You can find their contact details in the imprint of this website.',
        stand: 'As of January 2026',
      },
    },
  },
};

const STORAGE_KEY = 'ngbc_locale';

export function getStoredLocale() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'en' || stored === 'de') return stored;
  } catch (_) {}
  return 'de';
}

export function setStoredLocale(locale) {
  try {
    localStorage.setItem(STORAGE_KEY, locale);
  } catch (_) {}
}

export function getTranslation(locale, key) {
  const keys = key.split('.');
  let obj = translations[locale] || translations.de;
  for (const k of keys) {
    if (obj == null) return key;
    obj = obj[k];
  }
  return typeof obj === 'string' ? obj : key;
}
